import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { uniqueId } from 'lodash';
import classnames from 'classnames';
import Select from 'react-select';
import { fetchAbc } from '../../actions/reportActions';
import { fetchSets } from '../../actions/settings';
import { fnum, sortOpts } from '../../utils/utils';

class Abc extends React.Component{

  state = {
    sort: [['sum', false], ['desc', true]],
    filter: {
      from: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).from
        ) || moment().subtract(6, "months").format('Y-MM-DD')
      ),
      to: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).to
        ) || moment().add(1, "months").format('Y-MM-DD')
      ),
      exc_comp: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).exc_comp
        ) || ''
      ),
      exc_srvc: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).exc_srvc
        ) || ''
      ),
      perc: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).perc
        ) || '8015'
      ),
      subject: (
        (
          localStorage.abcFilter &&
          JSON.parse(localStorage.abcFilter).subject
        ) || 'comp'
      )
    }
  }

  componentWillMount(){
    this.refreshData();
    this.props.fetchSets('comp');
    this.props.fetchSets('srvc');
  }

  refreshData = () => {
    this.props.fetchAbc(this.state.filter);
  }

  handleFilterDate = (e, field) => {
    const filter = {
      ...this.state.filter,
      [field]: e.format('Y-MM-DD')
    };
    this.setState({filter});
    localStorage.abcFilter = JSON.stringify(filter);
  }

  handleSort = (e, field) => {
    const { sort } = this.state;
    if (field === sort[0][0]) {
      this.setState({
        sort: [
          [field, !sort[0][1]],
          sort[1]
        ]
      });
    }
    else {
      this.setState({
        sort: [
          [field, true],
          sort[0]
        ]
      });
    }
  }

  handleFilter = (e, field) => {
    const filter = {
      ...this.state.filter,
      [field]: e
    };
    this.setState({filter});
    localStorage.abcFilter = JSON.stringify(filter);
  }

  render() {
    const { abc: { data, sums }, comps, srvcs } = this.props;
    const { filter, sort } = this.state;

    const sorted = data && data.sort((a, b) => {
      if (a[sort[0][0]] < b[sort[0][0]]) return sort[0][1] ? -1 : 1;
      if (a[sort[0][0]] > b[sort[0][0]]) return sort[0][1] ? 1 : -1;
      if (a[sort[1][0]] < b[sort[1][0]]) return sort[1][1] ? -1 : 1;
      if (a[sort[1][0]] > b[sort[1][0]]) return sort[1][1] ? 1 : -1;
      return 0;
    });

    var srvcsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key)) {
        srvcsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
      }
    }
    srvcsOpt.sort(sortOpts);

    var compsOpt = [];
    for (key in comps){
      if(comps.hasOwnProperty(key)) {
        compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
      }
    }
    compsOpt.sort(sortOpts);

    const percOpt = [
      {label: '50-30-20', value: '5030'},
      {label: '80-15-5', value: '8015'}
    ];

    const subjectOpt = [
      {label: 'По компаниям', value: 'comp'},
      {label: 'По услугам', value: 'srvc'}
    ];

    return (
      <div>
        <h1>ABC анализ</h1>
        <div className="form-group form-inline">
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={subjectOpt}
              simpleValue
              value={filter.subject}
              clearable={false}
              onChange={(e) => this.handleFilter(e, 'subject')}
            />
          </div> Соотношение:
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={percOpt}
              simpleValue
              value={filter.perc}
              clearable={false}
              onChange={(e) => this.handleFilter(e, 'perc')}
            />
          </div>
        </div>
        <div className="form-group form-inline">
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.from)}
              selectsStart
              startDate={moment(filter.from)}
              endDate={moment(filter.to)}
              onChange={(e) => this.handleFilterDate(e, 'from')}
            />
          </div>{" - "}
          <div style={{display:'inline-block'}}>
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(filter.to)}
              selectsStart
              startDate={moment(filter.from)}
              endDate={moment(filter.to)}
              onChange={(e) => this.handleFilterDate(e, 'to')}
            />
          </div>{" Исключить: "}
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={srvcsOpt}
              multi
              simpleValue
              value={filter.exc_srvc.split(',').map(el => parseInt(el, 10))}
              onChange={(e) => this.handleFilter(e, 'exc_srvc')}
              placeholder="Услуга"
            />
          </div>{" "}
          <div className="input-group">
            <Select
              style={{width:'230px'}}
              options={compsOpt}
              multi
              simpleValue
              value={filter.exc_comp.split(',').map(el => parseInt(el, 10))}
              onChange={(e) => this.handleFilter(e, 'exc_comp')}
              placeholder="Компания"
            />
          </div>{" "}
          <button className="btn btn-success" onClick={this.refreshData}>
            Обновить
          </button>
        </div>
        {(data && data.length) ? (
          <table className="table table-striped">
            <thead>
              <tr>
                <th>№</th>
                <th
                  onClick={e => this.handleSort(e, 'desc')}
                  className="col-sm-6"
                >
                  Название
                </th>
                <th
                  onClick={e => this.handleSort(e, 'sum')}
                  className="col-sm-1"
                >
                  Валовая прибыль
                </th>
                <th className="text-right">%</th>
                <th
                  onClick={e => this.handleSort(e, 'margin')}
                  className="col-sm-1 text-right"
                >
                  Маржа
                </th>
                <th className="text-right">%</th>
                <th
                  onClick={e => this.handleSort(e, 'count')}
                  className="col-sm-1 text-right"
                >
                  Кол-во заказов
                </th>
                <th
                  onClick={e => this.handleSort(e, 'avgsum')}
                  className="col-sm-1 text-right"
                >
                  Сердняя цена
                </th>
                <th
                  onClick={e => this.handleSort(e, 'avgcost')}
                  className="col-sm-1 text-right"
                >
                  Сердняя себес-ть
                </th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((rec, index) => (
                <tr key={uniqueId()}>
                  <td>{index + 1}</td>
                  <td>{rec.desc}</td>
                  <td
                    className={classnames({
                      "text-right": true,
                      warning: rec.grade && rec.grade.sum === 'B',
                      success: rec.grade && rec.grade.sum === 'A'
                    })}
                  >
                    {fnum(rec['sum'])}
                  </td>
                  <td className="text-right">
                    {fnum(rec['sum']/sums['sum']*100, 1)}
                  </td>
                  <td
                    className={classnames({
                      "text-right": true,
                      warning: rec.grade && rec.grade.margin === 'B',
                      success: rec.grade && rec.grade.margin === 'A'
                    })}
                  >
                    {fnum(rec['margin'])}
                  </td>
                  <td className="text-right">
                    {fnum(rec['margin']/sums['margin']*100, 1)}
                  </td>
                  <td className="text-right">{fnum(rec['count'])}</td>
                  <td className="text-right">
                    {fnum(rec['sum']/rec['count'])}
                  </td>
                  <td className="text-right">
                    {fnum(rec['cost']/rec['count'])}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Загрузка данных...</div>
        )}
      </div>
    );
  }
}

function mapOrdersToProps(store){
  return {
    abc: store.reports.abc,
    comps: store.comps.data,
    srvcs: store.srvcs.data
  }
}

export default connect(mapOrdersToProps, { fetchAbc, fetchSets })(Abc);



// WEBPACK FOOTER //
// ./src/components/reports/Abc.js